<div *ngFor="let error of errors">
    {{customMessage ? customMessage : error}}
</div>
